import { Controller } from "@hotwired/stimulus"
import { showToast } from "../helpers/toast"

export default class extends Controller {
  static targets = ["banner"]
  static values = { fields: Array }

  bannerTargetConnected() {
    this.scrollToBanner()
    this.highlightInvalidFields()
  }

  scrollToBanner() {
    requestAnimationFrame(() => {
      this.bannerTarget.scrollIntoView({ behavior: "smooth", block: "center" })
    })
  }

  highlightInvalidFields() {
    this.fieldsValue.forEach(field => {
      const input = this.element.querySelector(`[name*="[${field}]"]`)
      if (input) {
        input.classList.add("border-red-400", "ring-1", "ring-red-400")
        input.addEventListener("focus", () => {
          input.classList.remove("border-red-400", "ring-1", "ring-red-400")
        }, { once: true })
      }
    })
  }

  // A required field failed the browser's constraint check on submit. The native
  // validation bubble can sit off-screen on iOS, so suppress it and instead scroll
  // the first offending field into view with a clear toast. `invalid` fires once
  // per field and doesn't bubble — wired with :capture on the <form>.
  flagRequired(event) {
    event.preventDefault()
    if (this.flagged) return
    this.flagged = true
    requestAnimationFrame(() => { this.flagged = false })

    const field = event.target
    field.scrollIntoView({ behavior: "smooth", block: "center" })
    // Deliberately NOT focusing the field: focusing a <select> pops its native
    // picker on iOS, which is jarring. The scroll + highlight + toast are enough.
    field.classList.add("border-red-400", "ring-1", "ring-red-400")
    field.addEventListener("input", () => {
      field.classList.remove("border-red-400", "ring-1", "ring-red-400")
    }, { once: true })

    showToast(`${this.labelFor(field)} is required`, { variant: "error" })
  }

  labelFor(field) {
    const text = field.labels?.[0]?.textContent || field.getAttribute("aria-label") || field.name
    return text.replace(/[*\s]+$/, "").trim() || "A field"
  }
}
